import { FirebaseApp, initializeApp } from 'firebase/app';
import { getGlobalConfig } from 'lib/config/globalConfig';

const {
  FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_DATABASE_URL,
  FIREBASE_PROJECT_ID,
  FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID,
} = getGlobalConfig();

const firebaseConfig = {
  apiKey: FIREBASE_API_KEY,
  authDomain: FIREBASE_AUTH_DOMAIN,
  databaseURL: FIREBASE_DATABASE_URL,
  projectId: FIREBASE_PROJECT_ID,
  appId: FIREBASE_APP_ID,
  measurementId: FIREBASE_MEASUREMENT_ID,
};

const app = (): FirebaseApp => {
  return initializeApp(firebaseConfig);
};

export default app;
